import { render, staticRenderFns } from "./UserStockWatchingList.vue?vue&type=template&id=512ad295&scoped=true&"
import script from "./UserStockWatchingList.vue?vue&type=script&lang=js&"
export * from "./UserStockWatchingList.vue?vue&type=script&lang=js&"
import style0 from "./UserStockWatchingList.vue?vue&type=style&index=0&id=512ad295&prod&scoped=true&lang=css&"
import style1 from "./UserStockWatchingList.vue?vue&type=style&index=1&id=512ad295&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512ad295",
  null
  
)

export default component.exports